<template>
    <div>
        <div class="form-row">
            <div class="col col-12 col-md-3">
                <div class="card overflow-auto" :style="altura">
                    <div class="card-body p-0">
                        <div class="list-group">
                            <!-- Retornos -->
                            <a href="#" class="list-group-item list-group-item-action list-group-item-primary small" 
                                :class="( sel_retornos && selecionado === null ) ? 'active' : ''" @click.prevent="sel_retornos = true; selecionado = null"
                                v-if="retornos && retornos.length">
                                <div>
                                    Retornos Previstos 
                                    <span class="badge badge-primary ml-2">
                                        {{ retornos.length }}
                                    </span>
                                </div>
                            </a>

                            <li class="list-group-item list-group-item-action list-group-item-secondary small d-flex justify-content-between"
                                v-if="filtro_periodo_aplicado && ( filtro_periodo_aplicado.dt_inicio || filtro_periodo_aplicado.dt_fim )">
                                <div>
                                    <strong>Período:</strong> 
                                    <span v-if="filtro_periodo_aplicado.dt_inicio && filtro_periodo_aplicado.dt_fim">
                                        {{ $util.getFormatDate(filtro_periodo_aplicado.dt_inicio) }} a {{ $util.getFormatDate(filtro_periodo_aplicado.dt_fim) }}
                                    </span>
                                    <span v-else-if="filtro_periodo_aplicado.dt_inicio">
                                        a partir de {{ $util.getFormatDate(filtro_periodo_aplicado.dt_inicio) }} 
                                    </span>
                                    <span v-else-if="filtro_periodo_aplicado.dt_fim">
                                        até {{ $util.getFormatDate(filtro_periodo_aplicado.dt_fim) }}
                                    </span>
                                </div>
                                <div>
                                    <button type="button" class="close py-0 my-0" @click="limpar_filtro_periodo()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </li>

                            <!-- Lista de Atendimentos -->
                            <a href="#" class="list-group-item list-group-item-action small" 
                                :class="( !sel_retornos && !legado && iix == selecionado ) ? 'active' : ''" @click.prevent="selecionar(marcacao, iix)"
                                :id="'hist' + iix"
                                v-for="(marcacao, iix) in lista" :key="iix"
                                @keydown.up.prevent="navegar_historico(false)"
                                @keydown.down.prevent="navegar_historico(true)">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        {{ getHumanDate(marcacao.dt_inicio) }} 
                                        <small class="ml-2">{{ getHumanDuration(marcacao.dt_inicio) }}</small>
                                        <span class="badge badge-danger ml-2" v-if="marcacao.ch_estado_marcacao == 'B'">
                                            Bloqueado
                                        </span>
                                        <span class="badge badge-danger ml-2" v-else-if="marcacao.ch_estado_marcacao == 'C'">
                                            Cancelado
                                        </span>
                                        <span class="badge badge-dark ml-2" v-else-if="marcacao.ch_estado_marcacao == 'A' && !marcacao.id_atendimento && marcacao.dt_inicio > $util.hoje()">
                                            Agendado
                                        </span>
                                        <span class="badge badge-danger ml-2" v-else-if="marcacao.ch_estado_marcacao == 'A' && !marcacao.id_atendimento && marcacao.dt_inicio < $util.hoje()">
                                            Falta
                                        </span>
                                    </div>

                                    <span v-if="marcacao.infusao && marcacao.in_qt_ciclo" class="ml-2" title="Ciclo / Dia">
                                        <i class="fa-solid fa-arrows-spin fa-fw mr-1"></i>
                                        C{{ marcacao.in_qt_ciclo }} / D{{ marcacao.in_qt_dia }}
                                    </span>
                                </div>
                                <div>
                                    <strong>{{ marcacao.procedimento.search }}</strong>
                                    <span v-if="marcacao.st_regiao" class="small ml-2" :class="( !sel_retornos && !legado && iix == selecionado ) ? 'text-white' : 'text-muted'">{{ marcacao.st_regiao }}</span>
                                    <span v-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && marcacao.atendimento.atendimento_procedimentos.length > 1" class="badge badge-primary ml-1">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                        {{ marcacao.atendimento.atendimento_procedimentos.length - 1 }}
                                    </span>
                                </div>
                                <div v-if="marcacao && marcacao.atendimento && marcacao.atendimento.fl_avulso && modelo_no_avulso(marcacao)" class="small">
                                    {{ modelo_no_avulso(marcacao) }}
                                </div>
                                <div v-if="marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos && marcacao.atendimento.atendimento_procedimentos.length > 1 && marcacao.atendimento.atendimento_procedimentos.length <= 10">
                                    <!-- Outros procedimentos em execução -->
                                    <span class="badge badge-pill ml-1" :class="'badge-' + atp.laudo.status_laudo.st_color" 
                                        :title="atp.procedimento.st_procedimento + ' / ' + atp.laudo.status_laudo.search"
                                        v-for="(atp, ilx) in marcacao.atendimento.atendimento_procedimentos.filter(item => item.laudo && item.procedimento.st_sigla)" :key="ilx">
                                        {{ atp.procedimento.st_sigla }}
                                    </span>
                                </div>
                                <div>
                                    {{ marcacao.medico.st_nome_exibicao }}
                                    <pep-item-micro-resumo :marcacao="marcacao" />
                                </div>
                            </a>

                            <!-- Lista de Atendimentos Legados -->
                            <a href="#" class="list-group-item list-group-item-action small" 
                                :class="( !sel_retornos && legado && iix == selecionado ) ? 'active' : ''" @click.prevent="selecionar(item, iix, true)"
                                v-for="(item, iix) in lista_legado" :key="'legado' + iix"
                                :id="'legado' + iix"
                                @keydown.up.prevent="navegar_historico(false)"
                                @keydown.down.prevent="navegar_historico(true)">
                                <div>
                                    {{ getHumanDate(item.dt_data) }} 
                                    <small class="ml-2">{{ getHumanDuration(item.dt_data) }}</small>
                                    <i class="fas fa-history ml-2"></i>
                                </div>
                                <div><strong>{{ item.st_descricao }}</strong></div>
                                <div>{{ item.st_nome_medico }}</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col col-12 col-md-9">
                <div class="card overflow-auto" :style="altura">
                    <div class="card-body p-0">
                        <pep-view-card 
                            :side="true"
                            :marcacao="conteudo" 
                            :tamanho="tamanho" 
                            :pode_atender="pode_atender"
                            v-if="!sel_retornos && !legado && conteudo" 
                            @abrirAtendimentoNaRecepcao="abrirAtendimentoNaRecepcao"
                            @retornarAoAtendimento="retornarAoAtendimento" 
                            @compartilhar="compartilhar"
                            @cancelar_marcacao="cancelar_marcacao"
                            @registrarAtendimento="registrarAtendimento"
                            @chamar="chamar"
                            @iniciarAtendimento="iniciarAtendimento"
                            @abrir_doc_view="abrir_doc_view" />

                        <pep-view-card-legado 
                            :tamanho="tamanho"
                            :side="true"
                            v-else-if="!sel_retornos && conteudo" 
                            :item="conteudo" />

                        <lista-retornos v-else-if="sel_retornos" :retornos="retornos" :aberto="true" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import PepViewCard from './PepViewCard.vue';
import PepViewCardLegado from './PepViewCardLegado.vue';
import PepItemMicroResumo from './PepItemMicroResumo.vue';
import ListaRetornos from '../../shared/ListaRetornos.vue';

export default {
    data() { 
        return { 
            items: [],
            conteudo: null, 
            selecionado: null,
            legado: false,  
            sel_retornos: false, 
        };
    },

    components: { 
        PepViewCard,
        PepViewCardLegado,
        PepItemMicroResumo, 
        ListaRetornos, 
    },
    
    computed: { 
        altura: function () { 
            let altura = ( this.paciente && this.paciente.paciente_unidade.st_lembrete ) ? 320 : 260;

            if ( this.marcacao_pra_chamar )
                altura = altura + 50;

            if ( !this.panel )
                altura = altura + 50;
            
            return 'height: calc(100vh - ' + altura + 'px);';
        },
    },

    props: ['lista', 'lista_legado', 'tamanho', 'pode_atender', 'paciente', 'marcacao_pra_chamar', 'panel', 'retornos', 'filtro_periodo_aplicado'],

    methods: { 
        modelo_no_avulso(marcacao) { 
            return _.get(marcacao, 'atendimento.atendimento_procedimentos.0.anamnese.modelo_prontuario.st_modelo_prontuario');
        },
        
        consultar_contatos (model_type, model_id) { 
            this.$parent.consultar_contatos(model_type, model_id);
        },
        
        limpar_filtro_periodo() { 
            this.$emit('limpar_filtro_periodo');
        },

        navegar_historico (down = true) { 
            if ( !this.legado ) { 

                if ( down ) { 
                    if ( this.selecionado === null ) { 
                        if ( this.lista && this.lista.length ) { 
                            this.selecionar(this.lista[0], 0, false);
                        }
                    } else { 
                        if ( this.lista && this.lista.length > this.selecionado + 1 ) { 
                            this.selecionar(this.lista[this.selecionado + 1], this.selecionado + 1, false);
                        } else if ( this.lista && this.lista.length == this.selecionado + 1 ) { 
                            if ( this.lista_legado.length ) { 
                                this.selecionar(this.lista_legado[0], 0, true);
                            }
                        }
                    } 
                } else if ( this.selecionado > 0 ) { 
                    this.selecionar(this.lista[this.selecionado - 1], this.selecionado - 1, false);
                }

            } else { 

                if ( down ) { 
                    if ( this.lista_legado && this.lista_legado.length > this.selecionado + 1 ) { 
                        this.selecionar(this.lista_legado[this.selecionado + 1], this.selecionado + 1, true);
                    }
                } else if ( this.selecionado > 0 ) { 
                    this.selecionar(this.lista_legado[this.selecionado - 1], this.selecionado - 1, true);
                } else if ( this.lista && this.lista.length ) { 
                    this.selecionar(this.lista[this.lista.length - 1], this.lista.length - 1, false);
                }
                
            }

        },

        abrir_doc_view(doc) { 
            this.$emit('abrir_doc_view', doc);
        },

        iniciarAtendimento(marcacao) { 
            this.$emit('iniciarAtendimento', marcacao);
        },

        chamar (marcacao) { 
            this.$emit('chamar', marcacao);
        },

        registrarAtendimento(marcacao) { 
            this.$emit('registrarAtendimento', marcacao);
        },

        cancelar_marcacao(marcacao) { 
            this.$emit('cancelar_marcacao', marcacao);
        },

        abrirAtendimentoNaRecepcao (marcacao) { 
            this.$emit('abrirAtendimentoNaRecepcao', marcacao);
        },

        retornarAoAtendimento(atendimento) { 
            this.$emit('retornarAoAtendimento', atendimento);
        },

        compartilhar(atendimento) { 
            this.$emit('compartilhar', atendimento);
        },
        
        selecionar(item, index, legado = false) { 
            this.sel_retornos = false;
            this.selecionado = index;
            this.conteudo = item;
            this.legado = legado;

            let el = document.getElementById(( legado ? 'legado' : 'hist' ) + index);

            if ( el ) { 
                el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        },

        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },
        getHumanDate(date) {
            return (
                moment(date, "YYYY-MM-DD").format("DD") +
                " de " +
                moment(date, "YYYY-MM-DD").format("MMMM") +
                (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
                ? ""
                : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
            );
        },
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) 
                return "hoje";
            else
                return moment.duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje())).humanize(true);
        },

    },

    mounted() { 
        if ( !this.conteudo && this.lista && this.lista.length ) { 
            this.selecionar(this.lista[0], '0');
        }
    }
}
</script>
